import type { BFFArticleBodyElement } from "@src/app/types/bff";

export default function ArticleSubHead({
  element,
}: {
  element: BFFArticleBodyElement["sub_head"];
}) {
  return <h4 className="text-header-4 pb-4">{element.value}</h4>;
}
